<p-dialog [(visible)]="dialogDisplay" [modal]="true" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '40vw' }">
  <div class="flex flex-column m-auto md:mx-6 text-center">
    <h2 class="text-center text-20">{{ 'SMART_GOALS.DIALOG.SUBMIT.TITLE' | translate }}</h2>
    <div class="mt-2 mb-4 text-sm">{{ 'SMART_GOALS.DIALOG.SUBMIT.DESCRIPTION' | translate }}</div>
    <div class="min-w-20rem align-self-center">
      <input
        pInputText
        [placeholder]="'SMART_GOALS.DIALOG.SUBMIT.EMAIL_PLACEHOLDER' | translate"
        class="w-full text-14"
        resize="none"
        id="email"
        [formControl]="email"
      />
      <p class="text-xxs text-left pt-1 pl-2">{{ 'SMART_GOALS.DIALOG.SUBMIT.EMAIL_NOTE' | translate }}</p>
    </div>
    <div class="block text-center">
      <p-button
        *ngIf="!loadingSubmit"
        (click)="submitSmartGoals()"
        [disabled]="email.invalid || loadingSubmit"
        styleClass="p-button-success text-sm my-4 p-3 w-12rem"
        [label]="'SMART_GOALS.DIALOG.SUBMIT.BUTTON' | translate"
        type="submit"
      >
      </p-button>
      <p-button
        *ngIf="loadingSubmit"
        styleClass="p-button-success text-sm my-4 p-3 w-12rem inline-block"
        type="button"
        [disabled]="email.invalid || loadingSubmit"
        ><i class="pi pi-spinner pi-spin"> </i> &nbsp; {{ 'SMART_GOALS.DIALOG.SUBMIT.SUBMITTING' | translate }}
      </p-button>
      <p class="text-xs max-w-17rem m-auto">{{ 'SMART_GOALS.DIALOG.SUBMIT.NOTE' | translate }}</p>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="innerDialogDisplay" [modal]="true" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '40vw' }">
  <div class="flex flex-column m-auto md:mx-6 align-items-center text-center">
    <h2 class="text-20 max-w-17rem">{{ 'SMART_GOALS.DIALOG.SAVED.TITLE' | translate }}</h2>
    <div class="mt-2 mb-3 text-sm line-height-2">
      {{ 'SMART_GOALS.DIALOG.SAVED.DESCRIPTION' | translate }}
    </div>
    <div class="block text-center">
      <p-button
        *ngIf="!loadingSubmit"
        (click)="notifyMentor()"
        [disabled]="loadingSubmit"
        styleClass="p-button-warning text-sm my-4 p-3 w-12rem"
        [label]="'SMART_GOALS.DIALOG.SAVED.BUTTON_NOTIFY' | translate"
        type="submit"
      >
      </p-button>
      <p-button
        *ngIf="loadingSubmit"
        styleClass="p-button-warning text-sm my-4 p-3 w-12rem inline-block"
        type="button"
        [disabled]="loadingSubmit"
        ><i class="pi pi-spinner pi-spin"> </i> &nbsp; {{ 'SMART_GOALS.DIALOG.SAVED.NOTIFYING' | translate }}
      </p-button>
    </div>
  </div>
</p-dialog>

<div *ngIf="!goalsSubmited; else submitedPage">
  <h1 *ngIf="source !== 'embed'" class="text-20 mb-5">{{ 'SMART_GOALS.TITLE.HELP' | translate }}</h1>
  <h1 *ngIf="source === 'embed'" class="mb-5">{{ 'SMART_GOALS.TITLE.DEFINE' | translate }}</h1>

  <span class="goals-text text-sm max-width-line">
    {{ 'SMART_GOALS.DESCRIPTION.INNER_BEFORE' | translate }}
    <a [routerLink]="smartGoalsTipsUrl">{{ 'SMART_GOALS.DESCRIPTION.INNER_LINK' | translate }}</a
    >.
    <br />
    <span [innerHTML]="'SMART_GOALS.DESCRIPTION.INNER_AFTER' | translate"></span>
  </span>

  <p *ngIf="source === 'public'" class="text-sm max-width-line">
    {{ 'SMART_GOALS.DESCRIPTION.PUBLIC' | translate }}
  </p>
  <div *ngIf="source === 'embed'">
    <p class="text-sm max-width-line">
      {{ 'SMART_GOALS.DESCRIPTION.EMBED' | translate }}
    </p>
    <div class="pt-3">
      <p class="font-bold text-14 pb-2">{{ 'SMART_GOALS.EXAMPLE.TITLE' | translate }}</p>
      <ol class="text-14 mt-0 example pl-3">
        <li>{{ 'SMART_GOALS.EXAMPLE.ITEM_1' | translate }}</li>
        <li>{{ 'SMART_GOALS.EXAMPLE.ITEM_2' | translate }}</li>
        <li>{{ 'SMART_GOALS.EXAMPLE.ITEM_3' | translate }}</li>
      </ol>
    </div>
  </div>

  <h2 class="text-20 line-height-2 mt-6">
    {{ 'SMART_GOALS.QUESTION.TITLE' | translate }}
  </h2>
  <form>
    <div class="grid">
      <div [ngClass]="{ 'col-12': true, 'lg:col-8': source !== 'embed' }">
        <textarea
          id="goalsUserInput"
          [formControl]="goalsUserInput"
          pInputTextarea
          [autoResize]="true"
          rows="8"
          class="text-14 w-full"
          [placeholder]="
            source === 'embed' ? ('SMART_GOALS.INPUT.PLACEHOLDER_EMBED' | translate) : ('SMART_GOALS.INPUT.PLACEHOLDER' | translate)
          "
        ></textarea>
        <div *ngIf="goalsUserInput.invalid && (goalsUserInput.dirty || goalsUserInput.touched) && showErrorBox" class="error-box">
          <div *ngIf="goalsUserInput.hasError('required')">{{ 'SMART_GOALS.INPUT.ERROR_REQUIRED' | translate }}</div>
          <div *ngIf="goalsUserInput.hasError('minlength')">{{ 'SMART_GOALS.INPUT.ERROR_MIN_LENGTH' | translate }}</div>
        </div>
        <div *ngIf="requestFailed" class="error-box">{{ 'SMART_GOALS.ERROR.SERVICE_UNAVAILABLE' | translate }}</div>
        <div *ngIf="requestInvalid" class="error-box">
          {{ 'SMART_GOALS.ERROR.INVALID_USAGE' | translate }}
        </div>
      </div>
      <div *ngIf="source !== 'embed'" class="col-12 lg:col-4">
        <div class="lg:pl-5 pt-3">
          <p class="font-bold text-14">{{ 'SMART_GOALS.EXAMPLE.TITLE' | translate }}</p>
          <ol class="text-14 mt-0 example">
            <li>{{ 'SMART_GOALS.EXAMPLE.ITEM_1' | translate }}</li>
            <li>{{ 'SMART_GOALS.EXAMPLE.ITEM_2' | translate }}</li>
            <li>{{ 'SMART_GOALS.EXAMPLE.ITEM_3' | translate }}</li>
          </ol>
        </div>
      </div>
    </div>
    <p-button
      *ngIf="!loadingGenerate"
      (click)="generateSmartGoals()"
      styleClass="p-button-warning text-sm mt-3 p-3 w-12rem  line-height-2"
      [label]="'SMART_GOALS.BUTTON.GENERATE' | translate"
      type="button"
      [disabled]="goalsUserInput.invalid || loadingGenerate"
    >
    </p-button>
    <p-button
      *ngIf="loadingGenerate"
      styleClass="p-button-warning text-sm mt-3 p-3 w-12rem inline-block line-height-2"
      type="button"
      [disabled]="goalsUserInput.invalid || loadingGenerate"
      ><i class="pi pi-spinner pi-spin"> </i> &nbsp; {{ 'SMART_GOALS.BUTTON.GENERATING' | translate }}
    </p-button>
  </form>

  <h2 class="text-20 line-height-2 mt-6">{{ 'SMART_GOALS.SUGGESTED.TITLE' | translate }}</h2>
  <form>
    <div class="grid">
      <div [ngClass]="{ 'col-12': true, 'lg:col-8': source !== 'embed' }">
        <textarea
          *ngIf="!showEditor"
          id="generatedGoals"
          [formControl]="generatedGoals"
          pInputTextarea
          [autoResize]="true"
          rows="8"
          class="text-14 w-full"
        >
        </textarea>
        <p-editor *ngIf="showEditor" id="generatedGoalsEditor" [formControl]="generatedGoals" class="text-14 w-full">
          <ng-template pTemplate="header">
            <span class="ql-formats">
              <button type="button" class="ql-bold" aria-label="Bold"></button>
              <button type="button" class="ql-italic" aria-label="Italic"></button>
              <button type="button" class="ql-underline" aria-label="Underline"></button>
              <button type="button" class="ql-list" value="ordered" aria-label="Ordered list"></button>
              <button type="button" class="ql-list" value="bullet" aria-label="Bullet list"></button>
            </span>
          </ng-template>
        </p-editor>
        <div *ngIf="generatedGoals.invalid && (generatedGoals.dirty || generatedGoals.touched) && showErrorBox" class="error-box">
          <div *ngIf="generatedGoals.hasError('required')">{{ 'SMART_GOALS.GENERATED.ERROR_REQUIRED' | translate }}</div>
          <div *ngIf="generatedGoals.hasError('minlength')">{{ 'SMART_GOALS.GENERATED.ERROR_MIN_LENGTH' | translate }}</div>
        </div>
        <p class="text-14 line-height-2 my-3">
          {{ 'SMART_GOALS.GENERATED.NOTE' | translate }}
          <a href="https://femmepalette.typeform.com/to/rdzFtw4D?typeform-source=www.google.com" target="_blank" class="underline">{{
            'SMART_GOALS.GENERATED.REPORT_BUG' | translate
          }}</a
          >.
        </p>
        <p *ngIf="source === 'public'" class="text-16">{{ 'SMART_GOALS.GENERATED.SUBMIT_NOTE' | translate }}</p>
      </div>
    </div>
    <ng-container *ngIf="source !== 'embed'">
      <p-button
        *ngIf="source === 'inner'"
        (click)="saveInnerGoals()"
        [disabled]="generatedGoals.invalid"
        styleClass="p-button-success text-sm mt-2 p-3"
        [label]="'SMART_GOALS.BUTTON.SAVE' | translate"
        type="submit"
      >
      </p-button>
      <p-button
        *ngIf="source === 'public'"
        (click)="generatedGoals.valid ? (dialogDisplay = true) : (dialogDisplay = false)"
        [disabled]="generatedGoals.invalid"
        styleClass="p-button-success text-sm mt-2 p-3"
        [label]="'SMART_GOALS.DIALOG.SUBMIT.BUTTON' | translate"
        type="submit"
      >
      </p-button
    ></ng-container>
  </form>
</div>

<ng-template #submitedPage>
  <div class="text-center flex flex-column justify-content-center mt-15vh">
    <h1 class="text-25">{{ 'SMART_GOALS.SUBMITTED.TITLE' | translate }}</h1>
    <p class="text-20 my-4">{{ 'SMART_GOALS.SUBMITTED.MESSAGE' | translate }}</p>
    <p-button
      (click)="goalsSubmited = false"
      styleClass="p-button-warning text-sm mt-2 p-3"
      [label]="'SMART_GOALS.SUBMITTED.BUTTON' | translate"
      type="button"
    >
    </p-button>
  </div>
</ng-template>
